/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

export interface GlobalErrorSlice {
  error: any;
  showErrorNotification: boolean;
}

const initialState: GlobalErrorSlice = {
  error: null,
  showErrorNotification: false,
};

const globalErrorReducer = createSlice({
  name: "globalError",
  initialState,
  reducers: {
    SET_ERROR: (state, action) => {
      state.error = action.payload.error;
    },
    SHOW_ERROR_NOTIFICATION: (state) => {
      state.showErrorNotification = true;
    },
    HIDE_ERROR_NOTIFICATION: (state) => {
      state.showErrorNotification = false;
    },
  },
});

export const { SET_ERROR, SHOW_ERROR_NOTIFICATION, HIDE_ERROR_NOTIFICATION } =
  globalErrorReducer.actions;

export default globalErrorReducer.reducer;
